<div
  class="bubble-row"
  [class.mine]="isMine"
  [class.theirs]="!isMine">

  <div class="bubble" [class.sent]="isMine" [class.received]="!isMine">
    <div class="bubble-header">
      <span class="sender-name">{{ isMine ? 'You' : message.senderDisplayName }}</span>
      <span class="time">{{ timeLabel }}</span>
    </div>

    <p class="bubble-text">{{ message.content }}</p>

    @if (isMine) {
      <span class="bubble-meta">
        <span class="status" [class.read]="message.status === 'read'">{{ statusIcon }}</span>
      </span>
    }
  </div>
</div>
